import styled from 'styled-components';

export const Wrapper = styled.div`
  background: rgba(0, 110, 73, 0.08);
  border-radius: 30px;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  padding: 48px 44px;
`;

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 118px 360px 264px 304px 1fr;
  padding: 4px 24px 23px 24px;
  gap: 0;
`;

export const TableRow = styled.div`
  display: grid;
  grid-template-columns: 118px 360px 264px 304px 1fr;
  padding: 18px 24px;
  gap: 0;
  border-radius: 12px;

  &:hover {
    background: rgba(255, 255, 255, 0.05);
  }
`;
